import React from "react";
import { toast } from "react-toastify";
import tools from "../../../helpers/tools";
import styles from "./LicensePlate.module.scss";

/**
 * Plaque d'immatriculation — visuel unique pour toute l'app.
 *
 * @param {string} value      Immatriculation brute (ex. "HH036MJ")
 * @param {"md"|"sm"} size    "sm" pour les lignes de devis et cartes de survol
 * @param {boolean} copyable  Clic / Entrée / Espace copient l'immat brute
 */
const LicensePlate = ({
  value,
  size = "md",
  copyable = true,
  className = "",
}) => {
  if (!value) return null;

  const copy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    toast.info(`${value} copié`);
  };

  const interactionProps = copyable
    ? {
        role: "button",
        tabIndex: 0,
        title: "Cliquer pour copier",
        onClick: copy,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            copy(e);
          }
        },
      }
    : {};

  return (
    <span
      className={[
        styles.plate,
        size === "sm" ? styles.sm : "",
        copyable ? styles.copyable : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...interactionProps}
    >
      {tools.formatImmat(value)}
    </span>
  );
};

export default LicensePlate;
